import { Component, Input, OnInit } from '@angular/core';
import { RequestId, RequestIdService } from '../../services/request-id.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FormService, SmsTimerService } from '@core/services';

import { Mode, ModeService } from './mode.service';
import { ModeInterface } from './mode/mode.interface';

@Component({
  selector: 'app-confirmation-code',
  templateUrl: './confirmation-code.component.html',
  styleUrls: ['./confirmation-code.component.scss']
})
export class ConfirmationCodeComponent implements OnInit {

  @Input() mode: Mode;

  titleText: string;
  loading: boolean;
  repeatLoading: boolean;

  requestId: RequestId = this.requestIdService.value;
  time = 0;


  codeForm: FormGroup;

  errorMap = {
    code: 'code'
  };

  confirmationService: ModeInterface;

  constructor(
    public form: FormBuilder,
    public formService: FormService,
    private requestIdService: RequestIdService,
    private router: Router,
    private smsTimerService: SmsTimerService,
    private modeService: ModeService
  ) {
    this.requestIdService.localStorage.subscribe(requestId => {
      this.requestId = requestId;
    });

    this.buildForm();
  }

  private init() {
    this.confirmationService = this.modeService.getService(this.mode);

    this.titleText = this.confirmationService.title;

    this.confirmationService.loadingObservable.subscribe((value => {
      this.loading = value;
    }));

    this.confirmationService.repeatLoadingObservable.subscribe((value => {
      this.repeatLoading = value;
    }));

    this.confirmationService.errorObservable.subscribe((errors => {
      if (errors) {
        this.formService.serverValidateForm(this.codeForm, errors, this.errorMap);
      }
    }));
  }

  private buildForm() {
    this.codeForm = this.form.group({
      code: [null, [Validators.required]]
    });
  }

  changeAccount() {
    this.requestIdService.reset();
    this.router.navigate(['/auth/login']);
  }

  repeat() {
    this.confirmationService.repeat();
  }

  submit() {
    this.loading = true;

    this.formService.markFormGroupTouched(this.codeForm);

    if (this.codeForm.invalid) {
      return this.loading = false;
    }

    this.confirmationService.submit(this.codeForm.controls.code.value);
  }

  ngOnInit() {
    this.init();

    if (!this.requestIdService.value) {
      this.router.navigate([this.confirmationService.startUrl]);
    }

    this.smsTimerService.onSmsTimer(this.requestIdService.value.time);

    this.smsTimerService.timer.subscribe(time => {
      this.time = time;
    });
  }
}


